var currency_symbol = $('body').attr('data-currency');

const US_WAREHOUSES = ['USA PAW Warehouse', 'USA NJF Warehouse', 'USA CAP Warehouse'];

function removeSkeleton(imgElement) {
  $(imgElement).siblings('.skeleton').fadeOut(300, function () {
    $(this).remove();
  });
}

function escapeSelector(str) {
  if (!str) return str;
  return str.replace(/([ #;&,.+*~':"!^$[\]()=>|/@])/g, '\\$1');
}

const INVENTORY_CACHE_TTL = 5000;
const inventoryRequestCache = new Map();

function fetchInventory(variantId) {
  const cleanId = parseInt(variantId, 10);

  if (Number.isNaN(cleanId)) {
    console.error('fetchInventory: invalid variantId', variantId);
    return Promise.resolve([]);
  }

  const cached = inventoryRequestCache.get(cleanId);
  const now = Date.now();

  if (
    cached &&
    now - cached.createdAt < INVENTORY_CACHE_TTL
  ) {
    return cached.promise;
  }

  const request = (async () => {
    try {
      const res = await fetch(
        `https://scripts.lifely.network/cloudflare/worker/cushie-inventory-status/inventory-api.php?variant_id=${cleanId}`,
        { cache: 'no-store' }
      );

      if (!res.ok) {
        console.error(
          'fetchInventory: HTTP error',
          res.status,
          res.statusText
        );
        return [];
      }

      const data = await res.json();

      if (!data.locations?.length) {
        console.warn(
          'fetchInventory: no locations returned for variant',
          cleanId
        );
        return [];
      }

      return data.locations.map((loc) => ({
        location: loc.location,
        quantity: loc.available
      }));
    } catch (err) {
      console.error('fetchInventory: fetch failed', err);
      return [];
    }
  })();

  inventoryRequestCache.set(cleanId, {
    createdAt: now,
    promise: request
  });

  window.setTimeout(() => {
    const cachedRequest = inventoryRequestCache.get(cleanId);

    if (cachedRequest?.promise === request) {
      inventoryRequestCache.delete(cleanId);
    }
  }, INVENTORY_CACHE_TTL);

  return request;
}

function getStockForLocations(inventory, locationNames) {
  const quantities = inventory
    .filter((item) => item && item.location && locationNames.includes(item.location))
    .map((item) => item.quantity);

  return {
    quantities,
    hasStock: quantities.some((qty) => qty > 0)
  };
}

/** Returns the quantity for a single named location, or null if not found. */
function getLocationQuantity(inventory, locationName) {
  const match = inventory.find((item) => item && item.location === locationName);
  return match ? match.quantity : null;
}

jQuery(document).ready(function ($) {
  var currencyCode = $('body').attr('data-currency-code');

  function updatePricing() {
    if (!$('.pricing-block').length) return;

    let current_variant_id = '';
    let selected_variant_title = '';

    // --- Build selected variant title dynamically ---
    const $variantOptions = $('.variant-productOption');
    const total_options = $variantOptions.length;

    if (total_options > 0) {
      const option1 = $('.variant-productOption[data-option-id="0"] .active').attr('data-value') || '';
      const option2 = $('.variant-productOption[data-option-id="1"] .active').attr('data-value') || '';
      const option3 = $('.variant-productOption[data-option-id="2"] .active').attr('data-value') || '';

      if (total_options === 1) {
        selected_variant_title = option1;
      } else if (total_options === 2) {
        selected_variant_title = `${option1} / ${option2}`;
      } else if (total_options === 3) {
        selected_variant_title = `${option1} / ${option2} / ${option3}`;
      }

      selected_variant_title = selected_variant_title.trim();
      if (selected_variant_title) {
        const safeTitle = CSS.escape(selected_variant_title);
        current_variant_id = $(`.pdpVariantData li[data-title='${safeTitle}']`).attr('data-vid') || '';
      }
    }

    if (!selected_variant_title) return;

    const $variant = $(`.pdpVariantData li[data-title='${selected_variant_title}']`);

    if (!$variant.length) {
      $('.pricing-block .sale-Price, .pricing-block .comp-Price, .wrap-badges .discount-Percent, .PDP-OFFER p.sale-price.sp-grid-pdp, .PDP-OFFER .PDP_Sale_offermsg').empty();
      return;
    }

    // --- Get prices ---
    let sale_price = parseFloat($variant.attr('data-price')) / 100 || 0;
    let compare_price = parseFloat($variant.attr('data-comp-price')) / 100 || 0;

    console.log(sale_price);
    console.log(compare_price);

    if (sale_price > 0) {
      let discountText = '';
      let difference = 0;
      let discountPercent = 0;

      if (compare_price > sale_price) {
        difference = compare_price - sale_price;
        discountPercent = Math.round((difference / compare_price) * 100);
        discountText = discountPercent > 0 ? discountPercent + '% Off' : '';
      }

      const currencyFormatOpts = { style: 'currency', currency: currencyCode, currencyDisplay: 'narrowSymbol' };
      const formattedDifference = difference.toLocaleString('en-US', currencyFormatOpts);
      const formattedSalePrice = sale_price.toLocaleString('en-US', currencyFormatOpts);

      $('.pricing-block .sale-Price').text(formattedSalePrice);
      
      if(compare_price > 0){
        const formattedCompPrice = compare_price.toLocaleString('en-US', currencyFormatOpts);
        $('.pricing-block .comp-Price').text(formattedCompPrice);
      }else{
        $('.pricing-block .comp-Price').text('');
      }

      if(discountText){
        $('.wrap-badges .discount-Percent').text(discountText);
        $('.PDP-OFFER .PDP_Sale_offermsg').text(discountText);
        $('.wrap-badges .discount-Percent').show();
        $('.PDP-OFFER .PDP_Sale_offermsg').show();
      }else{
        $('.wrap-badges .discount-Percent').hide();
        $('.PDP-OFFER .PDP_Sale_offermsg').hide();
      }
     
      $('.PDP-OFFER p.sale-price.sp-grid-pdp').text(difference > 0 ? `You Saved: ${formattedDifference}` : '');
    }
  }

  setTimeout(updatePricing, 1000); // --- Run on page load ---

  // --- Re-run on variant selection change ---
  $(document).on(
    'click',
    '.variant-productOption .config-item, .variant-productOption .product_color_values, .variant-productOption .seater-variant',
    function () {
      setTimeout(updatePricing, 100);
    }
  );
});


$(document).ready(function () {
  const galleryTypeConfig = {
    original: {
      wrapperSelector: '.heroGalleryWrapper.originalGallery',
      innerSelector: '.productGalleryInner.productGalleryOriginal',
      shimmerSelector: '.shimmerOldGallery',
      includeImageDimensions: true,
      nonFirstFetchPriority: 'low'
    },
    lifestyle: {
      wrapperSelector: '.heroGalleryWrapper.lifestyleGallery',
      innerSelector: '.productGalleryInner.productGalleryLifestyle',
      shimmerSelector: '.shimmerGallery',
      includeImageDimensions: false,
      nonFirstFetchPriority: 'high'
    }
  };

  $('.add-to-cart-holder .atcButtonWrap input.add-to-cart-button').on('click', function () {
    $(this).find('img.cart-icon3').hide();
  });

  function initShimmerSwiper(wrapperSelector) {
    const thumbsSwiper = new Swiper(`${wrapperSelector} .product_meta_swiper`, {
      slidesPerView: 4,
      watchSlidesProgress: true,
      spaceBetween: 20,
      grabCursor: true,
      breakpoints: {
        300: { slidesPerView: 5, spaceBetween: 5, showSwitchArrows: false },
        1150: { slidesPerView: 4, spaceBetween: 10, showSwitchArrows: false }
      }
    });

    new Swiper(`${wrapperSelector} .product_main_slider`, {
      slidesPerView: 1,
      spaceBetween: 10,
      watchOverflow: false,
      thumbs: { swiper: thumbsSwiper }
    });
  }

  initShimmerSwiper(galleryTypeConfig.original.wrapperSelector);
  initShimmerSwiper(galleryTypeConfig.lifestyle.wrapperSelector);

  $(document).on('click', '.product_thumbnail_slider img.pdpThumbnailVideo', function () {
    var videoUrl = $(this).attr('data-video-url');
    var sourceHtml = $('.PdpVideoWrapper video').html();
    var index = $(this).closest('[data-slide]').attr('data-slide');

    if (!videoUrl || videoUrl === 'undefined') {
      console.warn('Invalid video URL');
      return;
    }

    $(this)
      .closest('.hero-video')
      .find('.product_media_list')
      .each(function () {
        var slideIndex = $(this).attr('data-slide');

        if (index === slideIndex) {
          var $video = $(this).find('.pswp__custom-video-wrapper video');
          var $source = $video.find('source');
          var $img = $(this).find('.pswp__custom-video-wrapper img');

          if ($source.attr('src') !== videoUrl) {
            $video.html(sourceHtml);
            $video[0].load();
          }

          $video.removeClass('hide');
          $video[0].play();

          $video.off('play').on('play', function () {
            $img.addClass('hide');
          });
        } else {
          var $otherVideo = $(this).find('.pswp__custom-video-wrapper video');
          var $otherImg = $(this).find('.pswp__custom-video-wrapper img');

          $otherVideo[0]?.pause();
          $otherVideo.addClass('hide');
          $otherImg.removeClass('hide');
        }
      });
  });

  $(document).on('click', '.pdp-menu-left a', function (e) {
    e.preventDefault();

    const targetId = $(this).attr('href');
    const targetEl = $(targetId);

    if (targetEl.length) {
      $('html, body').animate({ scrollTop: targetEl.offset().top }, 600);
    }
  });

  $('.product_meta_size_guide').click(function () {
    $('.product_meta_size_guide_container').addClass('active_popup');
    $('.product_meta_size_guide.1seater').length &&
      $('.product_size_table').css('width', '100%') &&
      $('.sofa_meta_popup_size_image > img').css({ width: '80%', display: 'block', margin: 'auto' });
  });

  $('.product_meta_close_size').click(function () {
    $('.product_meta_size_guide_container').removeClass('active_popup');
  });

  $('.seater-variant').hide();

  var active_config_name = $('.configuration-options .config-item.active_configure').attr('data-config-value') || '';
  var active_seater = $('.seater-variant.active').attr('seater-value') || '';
  var active_color = $('.product_color_values.active_color').attr('data-color') || '';

  // ---- Pre-select variant from URL ?variant= param, or fall back to first option ----
  const urlParams = new URLSearchParams(window.location.search);
  const variantIdFromUrl = urlParams.get('variant');

  if (variantIdFromUrl) {
    const targetVariant = $(`.modular_variants option[variant-id="${variantIdFromUrl}"]`);

    if (targetVariant.length) {
      const variantOptions = {};
      $.each(targetVariant[0].attributes, function () {
        if (this.name.startsWith('variant-option')) {
          const index = parseInt(this.name.split('variant-option')[1]) - 1;
          variantOptions[index] = this.value.trim();
        }
      });

      const optionNames = [];
      $('.modular_variants option')
        .first()
        .each(function () {
          $.each(this.attributes, function () {
            if (this.name.startsWith('variant-option')) {
              const i = parseInt(this.name.replace('variant-option', '')) - 1;
              optionNames[i] = this.name;
            }
          });
        });

      for (let i = 0; i < optionNames.length; i++) {
        const value = variantOptions[i];
        const label = $('.variant-productOption-' + i).attr('data-option')?.toLowerCase() || '';

        if (label.includes('configuration') || label.includes('size')) {
          $('.configuration-options .config-item').removeClass('active_configure active');

          const configItem = $('.configuration-options .config-item').filter(function () {
            return $(this).data('config-value') === value;
          });

          if (configItem.length) {
            configItem.addClass('active_configure active');
            $('#selected-config').text(value);
          } else {
            console.warn('Config item not found for value:', value);
          }
        }

        if (label.includes('seater')) {
          $('.seater-variant').hide().removeClass('active');

          const seaterValue = value;
          let main_variant = 'sleeper';

          if (seaterValue.toLowerCase().includes('l-shaped')) {
            main_variant = 'l-shaped';
          } else if (seaterValue.toLowerCase().includes('u-shaped')) {
            main_variant = 'u-shaped';
          } else if (seaterValue.toLowerCase().includes('sectional')) {
            main_variant = 'sectional';
          }

          const seaterVariants = $(`.seater-variant[seater-variant="${escapeSelector(main_variant)}"]`);
          seaterVariants.show();

          const seaterItem = seaterVariants.filter(function () {
            return $(this).attr('seater-value') === seaterValue;
          });

          if (seaterItem.length) {
            seaterItem.addClass('active');
            $('.selected_seater_title').text(seaterValue);
          } else {
            console.warn('Seater item not found for value:', seaterValue);
          }
        }

        if (label.includes('color') || label.includes('colour')) {
          $('.product_color_values').removeClass('active_color active');

          const colorItem = $('.product_color_values').filter(function () {
            return $(this).data('color') === value;
          });

          if (colorItem.length) {
            colorItem.addClass('active_color active');
            $('.selected_color_name').text(value);
          } else {
            console.warn('Color item not found for value:', value);
          }
        }
      }
    }
  } else {
    const firstConfigItem = $('.configuration-options .config-item').first();
    firstConfigItem.addClass('active_configure active');
    $('#selected-config').text(firstConfigItem.data('config-value'));

    const config_name = firstConfigItem.attr('data-config-name');
    const seaterVariants = $(`.seater-variant[seater-variant="${config_name}"]`);
    const firstSeater = seaterVariants.first();
    seaterVariants.show();
    firstSeater.addClass('active');
    $('.selected_seater_title').text(firstSeater.attr('seater-value'));

    const firstColor = $('.product_color_values').first();
    firstColor.addClass('active_color active');
    $('.selected_color_name').text(firstColor.data('color'));
  }

  function formatPrice(price) {
    return price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function renderProductGallery(matching_variant_id, type) {
    if ($('.productGalleryWrapper').length === 0) return;

    const config = galleryTypeConfig[type];
    const $wrapper = $(config.wrapperSelector);
    const $realGallery = $wrapper.find('#real-gallery');
    const $shimmer = $wrapper.find(config.shimmerSelector);

    $realGallery.hide();
    $shimmer.show();

    let parent_slider = '';
    let child_slider = '';
    let main_slider_html = '';

    $(`.productGalleryWrapper ${config.innerSelector} .hero-video-wrapper`).each(function () {
      const index = $(this).attr('data-loop');

      if ($(this).attr('data-variant-id') != matching_variant_id) return;

      let parent_slide = '';
      let child_slide = '';

      $(this)
        .find('.product-gallery-parent')
        .each(function () {
          const loop_index = $(this).attr('data-index');
          let slide = '';

          if ($(this).attr('data-has-video') === 'true') {
            slide = `<div class="pswp__custom-video-wrapper">
                <video class="hero-video pdpGalleryVideo hide" autoplay loop muted playsInline aria-label="Hero Video" poster="">
                  <source src="" type="video/mp4">
                </video>
              </div>`;
          } else {
            const image = $(this).attr('data-image-url');
            const fetchPriority = loop_index == 0 ? 'high' : config.nonFirstFetchPriority;
            const loading = loop_index == 0 ? 'eager' : 'lazy';

            slide = config.includeImageDimensions
              ? `<img src="${image}" srcset="${image}" sizes="100vw" alt="image" class="hero-video" fetchpriority="${fetchPriority}" loading="${loading}" width="767" height="559" style="aspect-ratio:59/43;">`
              : `<img src="${image}" sizes="100vw" alt="image" class="hero-video" fetchpriority="${fetchPriority}" loading="${loading}">`;
          }

          parent_slide += `<div class="swiper-slide product_media_list" data-slide="${loop_index}">${slide}<div class="product__zoom"><button id="enable-zoom"><i class="fa-solid fa-magnifying-glass-plus"></i></button></div></div>`;
        });

      $(this)
        .find('.product-thumbnails')
        .each(function () {
          const loop_index = $(this).attr('data-index');
          let slide = '';

          if ($(this).attr('data-has-video') === 'true') {
            const image = $(this).attr('data-video-thumb');
            const video = $(this).attr('data-video-url');
            slide = config.includeImageDimensions
              ? `<img class="cms-slide pdpThumbnailVideo" var-id="${matching_variant_id}" src="${image}" srcset="${image}" data-video-url="${video}" width="130" height="120" style="aspect-ratio:13/12;">`
              : `<img class="cms-slide pdpThumbnailVideo" var-id="${matching_variant_id}" src="${image}" data-video-url="${video}">`;
          } else {
            const image = $(this).attr('data-product-thumb');
            slide = config.includeImageDimensions
              ? `<img class="cms-slide" var-id="${matching_variant_id}" src="${image}" srcset="${image}" loading="lazy" width="130" height="120" style="aspect-ratio:13/12;">`
              : `<img class="cms-slide" var-id="${matching_variant_id}" src="${image}" loading="lazy">`;
          }

          child_slide += `<div role="listitem" class="swiper-slide w-dyn-item w-col w-col-3" data-slide="${loop_index}">${slide}</div>`;
        });

      if (parent_slide) {
        parent_slider = `
          <div class="product_media">
            <div class="product_main_slider swiper swiper-${index} product_main_slider-${index}">
              <div class="swiper-wrapper product_slider_media">${parent_slide}</div>
              <div class="swiper-pagination main_pagination-${index}"></div>
            </div>
          </div>`;
      }

      if (child_slide) {
        child_slider = `
          <div class="product_thumbnail_slider product_thumbnail_slider-${index}">
            <div class="swiper is-slider-main w-dyn-list product_meta_swiper swiper-${index} product_meta_swiper-${index}" udy-collection="cfp" id="${matching_variant_id}">
              <div role="list" class="swiper-wrapper is-slider-main w-dyn-items w-row">${child_slide}</div>
            </div>
            <div class="thumbs_pagination"></div>
            <div class="swiper-button-prev swiper-button-prev-${index}"></div>
            <div class="swiper-button-next swiper-button-next-${index}"></div>
          </div>`;
      }

      if (parent_slider && child_slider) {
        main_slider_html = `
          <div class="hero-video other firts_product_media bg-hero cls-${matching_variant_id}" product-media-variant="${matching_variant_id}">
            ${parent_slider}
            ${child_slider}
          </div>`;
      }

      if (main_slider_html) {
        setTimeout(function () {
          $realGallery.html(main_slider_html);
          const variants_size = $('.productGalleryWrapper').attr('data-variant-size');
          initGallerySwipers(variants_size, type);
          $realGallery.show();
          $shimmer.hide();
        }, 500);
      }
    });
  }

  function rendernewProductGalleryByVariantId(matching_variant_id) {
    const $wrapper = $('.heroGalleryWrapper.newGallery');
    const $shimmer = $wrapper.find('.shimmerNewGallery');
    const $galleryContainer = $wrapper.find('#new-real-gallery');
    const $galleryWrapper = $wrapper.find('.new-pdp-testing');

    /* $galleryWrapper.hide();
    $shimmer.show(); */

    const $serverFirstImage = $galleryContainer.find('[data-server-rendered-first-image]').first();

    const canReuseServerImage =
      $serverFirstImage.length > 0 &&
      String($serverFirstImage.attr('data-server-variant-id')) ===
        String(matching_variant_id);

    if (canReuseServerImage) {
      $galleryWrapper.show();
      $shimmer.hide();
    } else {
      $galleryWrapper.hide();
      $shimmer.show();
    }

    if ($('.productGalleryWrapper').length === 0) {
      console.log('productGalleryWrapper not found');
      $shimmer.hide();
      return;
    }

    if ($galleryContainer.length === 0) {
      console.log('#new-real-gallery not found');
      $shimmer.hide();
      return;
    }

    let gallery_html = '';
    let variantFound = false;

    $('.productGalleryWrapper .productGalleryInner.productGalleryOriginal .hero-video-wrapper').each(function () {
      const variantId = $(this).attr('data-variant-id');

      if (variantId != matching_variant_id) return;

      variantFound = true;

      const isMobileViewport = window.matchMedia(
        '(max-width: 767px)'
      ).matches;

      let galleryItems = '';
      let imageCount = 0;

      $(this)
        .find('.product-gallery-parent')
        .slice(0, 11)
        .each(function () {
          const loopIndex = Number(
            $(this).attr('data-index') || 0
          );

          const hasVideo =
            $(this).attr('data-has-video') === 'true';

          if (hasVideo) {
            const videoUrl =
              $(this).attr('data-video-url');

            if (!videoUrl) return;

            imageCount++;

            const videoMarkup = `
              <video autoplay muted loop playsinline>
                <source src="${videoUrl}" type="video/mp4">
              </video>`;

            galleryItems += isMobileViewport
              ? `<div class="swiper-slide">${videoMarkup}</div>`
              : `<div class="gallery-item">${videoMarkup}</div>`;

            return;
          }

          const image = $(this).attr('data-image-url');
          const imageSrcset =
            $(this).attr('data-image-srcset') || '';

          if (!image) return;

          imageCount++;

          const isFirstImage = loopIndex === 0;

          const imgMarkup = `<img
            src="${image}"
            srcset="${imageSrcset}"
            sizes="(max-width: 767px) 100vw, 410px"
            alt=""
            loading="${isFirstImage ? 'eager' : 'lazy'}"
            fetchpriority="${isFirstImage ? 'high' : 'low'}"
            width="767"
            height="559"
            style="aspect-ratio: 59 / 43;"
          >`;

          galleryItems += isMobileViewport
            ? `<div class="swiper-slide">${imgMarkup}</div>`
            : `<div class="gallery-item">${imgMarkup}</div>`;
        });

      if (imageCount <= 1) {
        $shimmer.hide();
        $galleryWrapper.hide();
        return false;
      }

      gallery_html = isMobileViewport
        ? `
          <div class="product-gallery">
            <div class="swiper mobile-gallery">
              <div class="swiper-wrapper">${galleryItems}</div>
              <div class="swiper-pagination"></div>
            </div>
          </div>`
        : `
          <div class="product-gallery">
            <div class="gallery-grid">${galleryItems}</div>
          </div>`;

      return false;
    });

    if (!variantFound) {
      console.log('Variant not found');
      $shimmer.hide();
      return;
    }

    /* $galleryContainer.html(gallery_html); */

    if (canReuseServerImage) {
      const $preservedImage = $serverFirstImage.detach();

      $galleryContainer.html(gallery_html);

      const $generatedFirstImage = $galleryContainer.find('img').first();

      if ($generatedFirstImage.length) {
        $generatedFirstImage.replaceWith($preservedImage);
        $preservedImage.removeAttr(
          'data-server-rendered-first-image data-server-variant-id'
        );
      }
    } else {
      $galleryContainer.html(gallery_html);
    }

    if (window.mobileGallerySwiper) {
      window.mobileGallerySwiper.destroy(true, true);
    }

    setTimeout(function () {
      if ($galleryContainer.find('.mobile-gallery').length) {
        window.mobileGallerySwiper = new Swiper('#new-real-gallery .mobile-gallery', {
          slidesPerView: 1,
          spaceBetween: 10,
          pagination: { el: '#new-real-gallery .swiper-pagination', clickable: true }
        });
      }

      $shimmer.hide();
      $galleryWrapper.show();
    }, 500);
  }

  function initGallerySwipers(variantCount, type) {
    const config = galleryTypeConfig[type];

    for (let i = 1; i <= variantCount; i++) {
      const product_thumbs_swiper = new Swiper(`${config.wrapperSelector} .product_meta_swiper-${i}`, {
        slidesPerView: 4,
        watchSlidesProgress: true,
        spaceBetween: 20,
        grabCursor: true,
        navigation: { nextEl: `.swiper-button-next-${i}`, prevEl: `.swiper-button-prev-${i}` },
        breakpoints: {
          300: { slidesPerView: 5, spaceBetween: 5 },
          1150: { slidesPerView: 4, spaceBetween: 10 }
        }
      });

      new Swiper(`${config.wrapperSelector} .product_main_slider-${i}`, {
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: { el: `.main_pagination-${i}`, clickable: true },
        thumbs: { swiper: product_thumbs_swiper },
        on: {
          slideChange: function () {
            const activeIndex = this.activeIndex;
            const sourceHtml = $('.PdpVideoWrapper video').html();
            const videoUrl = $('.PdpVideoWrapper video source').attr('src');
            const $sliderContainer = $(this.el).closest('.hero-video');

            $sliderContainer.find('.product_media_list').each(function () {
              const slideIndex = parseInt($(this).attr('data-slide'), 10);
              const $video = $(this).find('.pswp__custom-video-wrapper video');
              const $source = $video.find('source');
              const $img = $(this).find('.pswp__custom-video-wrapper img');

              if (slideIndex === activeIndex) {
                if ($video.length > 0 && $source.length > 0) {
                  if ($source.attr('src') !== videoUrl) {
                    $video.html(sourceHtml);
                    $video[0].load();
                  }
                  $video.removeClass('hide');
                  $video[0].play();
                  $video.off('play').on('play', function () {
                    $img && $img.length && $img.addClass('hide');
                  });
                }
              } else if ($video.length > 0 && $video[0]) {
                $video[0].pause();
                $video.addClass('hide');
                $img && $img.length && $img.removeClass('hide');
              }
            });
          }
        }
      });
    }
  }

  function renderStockStatus(current_variant_id, inStock, marketPrefix, allowPreorder) {
    if (inStock) {
      $('.stock-status-card .shipment-header').html(`<span class="status-dot in-stock"><svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9.5" cy="9.5" r="5" fill="#59A169"/>
        <circle cx="9.5" cy="9.5" r="6.875" stroke="#59A169" stroke-opacity="0.3" stroke-width="3.75"/>
        </svg>
        </span>
        <strong>In stock, ships in 1-2 business days </strong>`);

      $('.stock-status-card .timeline .timeline-item[data-id="1"] .datelabel').text('In Warehouse Now');
      $('.stock-status-card .timeline .timeline-item[data-id="1"] .datecontent').html('<strong>In Stock, Ships in 1-2 days</strong>');

      $('#primar-button').val('Add to cart').prop('disabled', false).attr('data-value', 'Add to cart');
      $('#sticky-atc-btn').text('Add to cart').attr('data-value', 'Add to cart');
      $('#primar-button')
        .closest('.atcButtonWrap')
        .find('.cart_pre_order_icon')
        .attr('src', 'https://cdn.shopify.com/s/files/1/0745/0876/3427/files/shopping-cart-white.svg?v=1756128418');
    } else {
      const $bulkUg = $(`.bulkUrgencyWrap .bulk-ug[data-vid="${current_variant_id}"]`);
      const preorderText = $bulkUg.attr(`data-${marketPrefix}-preorder`);
      const deliveryDate = $bulkUg.attr(`data-${marketPrefix}-date`);
      const hasPreorderData = preorderText && preorderText !== 'undefined';

      // Only ever show Pre-Order if BOTH the policy allows it AND we have preorder copy to show
      if (allowPreorder && hasPreorderData) {
        $('.stock-status-card .shipment-header').html(`<span class="status-dot pre-order">
          <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="9" cy="9.5" r="5" fill="#BA3F3F"></circle>
          <circle cx="9" cy="9.5" r="6.875" stroke="#BA3F3F" stroke-opacity="0.3" stroke-width="3.75"></circle>
          </svg>
        </span><strong>Pre Order, ${preorderText}</strong>`);

        $('.stock-status-card .timeline .timeline-item[data-id="1"] .datelabel').text('Next Batch Ships in');
        $('.stock-status-card .timeline .timeline-item[data-id="1"] .datecontent').html(`<strong>${deliveryDate}</strong>`);
        $(`.variant_estimate_date[data-variant="${current_variant_id}"]`).attr('data-ship-date', deliveryDate);

        $('#primar-button').val('Pre-Order').prop('disabled', false).attr('data-value', 'Pre-Order');
        $('#sticky-atc-btn').text('Pre-Order').attr('data-value', 'Pre-Order');
        $('#primar-button')
          .closest('.atcButtonWrap')
          .find('.cart_pre_order_icon')
          .attr('src', 'https://cdn.shopify.com/s/files/1/0745/0876/3427/files/timer.png?v=1747280079')
          .show();
      }else {
        // Policy says 0 (no preorder) → genuinely out of stock
        $('.stock-status-card .shipment-header').html(`<span class="status-dot out-of-stock">
          <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="9.5" cy="9.5" r="5" fill="#9B9B9B"/>
          <circle cx="9.5" cy="9.5" r="6.875" stroke="#9B9B9B" stroke-opacity="0.3" stroke-width="3.75"/>
          </svg>
          </span>
          <strong>Out of stock</strong>`);

        $('.stock-status-card .timeline .timeline-item[data-id="1"] .datelabel').text('Currently Unavailable');
        $('.stock-status-card .timeline .timeline-item[data-id="1"] .datecontent').html('<strong>Out of Stock</strong>');

        $('#primar-button').val('Out Of Stock').prop('disabled', true).attr('data-value', 'Out Of Stock');
        $('#sticky-atc-btn').text('Out Of Stock').attr('data-value', 'Out Of Stock');
        $('.add-to-cart-holder .cart_pre_order_icon').hide();
      }
    }

    $('.stock-status-card').removeClass('loading');
  }

  function product_data(active_config_name, active_seater, active_color) {

    $('.mainProduct .firts_product_media').addClass('hide');
    let matching_variant_id = null;

    $('.modular_variants option').each(function () {
      const variantOptions = {
        option1: $(this).attr('variant-option1') || '',
        option2: $(this).attr('variant-option2') || '',
        option3: $(this).attr('variant-option3') || ''
      };

      const match =
        (!active_config_name || [variantOptions.option1, variantOptions.option2, variantOptions.option3].includes(active_config_name)) &&
        (!active_seater || [variantOptions.option1, variantOptions.option2, variantOptions.option3].includes(active_seater)) &&
        (!active_color || [variantOptions.option1, variantOptions.option2, variantOptions.option3].includes(active_color));

      if (match) {
        matching_variant_id = $(this).attr('variant-id');
        return false;
      }
    });


    // Only on initial page load
    if (!window.variantInitializedFromURL) {

        const urlVariant = new URLSearchParams(window.location.search).get('variant');

        if (urlVariant) {

            const option = $(`.modular_variants option[variant-id="${urlVariant}"]`);

            if (option.length) {
                matching_variant_id = urlVariant;
                console.log("Using URL variant:", matching_variant_id);
            }
        }

        window.variantInitializedFromURL = true;
    }

    if (!matching_variant_id) return;

    $('.variant_estimate_date').addClass('hide');
    $('.product_meta_size_information').attr('variant-size-id', matching_variant_id);
    $('.product_meta_popup_variant').attr('product-var-id', matching_variant_id);
    $('product_meta_size_accordion').attr('variant-size-id', matching_variant_id);
    $('.product_delivery_meta_content').attr('variant-id', matching_variant_id);
    $('.pre-order-info-div.pre_order_information').attr('variant-id', matching_variant_id);

    /* const $sizeGuideData = $(`.contentSizeguide-multiple-section .productSizeGuideInfo[data-var-id="${matching_variant_id}"]`); */

    const sizeGuideTemplate = document.getElementById(
      'product-size-guide-data'
    );
    const sizeGuideDataNode = sizeGuideTemplate?.content.querySelector(`.productSizeGuideInfo[data-var-id="${matching_variant_id}"]`);
    const $sizeGuideData = $(sizeGuideDataNode || []);

    const sizeguide_popup_content = $sizeGuideData.find('.productPopupInformation').html();
    const sizeguide_accordion_content = $sizeGuideData.find('.productAccordionInformation').html();
    const sizeguide_section_content = $sizeGuideData.find('.productSizeInformation').html();
    const delivery_meta_content = $sizeGuideData.find('.productDeliveryContent').html();
    const preorder_info = $sizeGuideData.find('.productPreOrderInfo').html();

    if (sizeguide_popup_content) $('.product_meta_popup_variant').html(sizeguide_popup_content);
    if (sizeguide_accordion_content) $('.product_meta_size_accordion').html(sizeguide_accordion_content);
    if (sizeguide_section_content) $('.product_meta_size_information').html(sizeguide_section_content);
    if (delivery_meta_content) $('.product_delivery_meta_content').html(delivery_meta_content);
    if (preorder_info) $('.pre-order-info-div.pre_order_information').html(preorder_info);

    // ---- Sale price logic (specific to the cushie-modular-sleeper-sofa PDP) ----
    const currentUrl = window.location.pathname;
    if (currentUrl.includes('/cushie-modular-sleeper-sofa')) {
      const optionElement = $(`.modular_variants option[variant-id="${matching_variant_id}"]`);
      const sale_price = parseFloat(optionElement.attr('variant-sale-price'));
      const discount_number = parseFloat($('.discount_value').attr('discount'));

      if (!isNaN(sale_price) && !isNaN(discount_number)) {
        const discounted_price = sale_price - (sale_price * discount_number) / 100;
        Shopify.formatMoney(discounted_price); // kept for parity - result currently unused
      }

      const percentValue = parseFloat($('.sale_left_content').data('percent-value')) || 0;
      const minusValue = parseFloat($('.sale_left_content').data('minus-value')) || 0;

      const variantPrice =
        percentValue > 0 ? (sale_price - (sale_price * percentValue) / 100).toFixed(2) : (sale_price - minusValue).toFixed(2);

      $('span.variant-price').text(`$${Shopify.formatMoney(variantPrice, '{{amount}}')}`);
      $('span.original-price>s').text(`$${Shopify.formatMoney(sale_price.toFixed(2), '{{amount}}')}`);
    }


    let current_variant_id = '';
    let selected_variant_title = '';

    if ($('.pdpVariantData').length > 0 && $('.variant-productOption').length > 0) {
      const total_options = $('.variant-productOption').length;
      const option1 = $('.variant-productOption[data-option-id="0"] .active').attr('data-value');
      const option2 = $('.variant-productOption[data-option-id="1"] .active').attr('data-value');
      const option3 = $('.variant-productOption[data-option-id="2"] .active').attr('data-value');

      if (total_options == 1) {
        selected_variant_title = option1;
      } else if (total_options == 2) {
        selected_variant_title = option1 + ' / ' + option2;
      } else if (total_options == 3) {
        selected_variant_title = option1 + ' / ' + option2 + ' / ' + option3;
      }

      if (selected_variant_title) {
        current_variant_id = $(`.pdpVariantData li[data-title='${selected_variant_title}']`).attr('data-vid');
      }
    }


    const $newGallery = $('.heroGalleryWrapper.newGallery');

    if ($newGallery.length && $newGallery.is(':visible')) {
      console.log('NEW GALLERY CONDITION');
      rendernewProductGalleryByVariantId(current_variant_id);
    }else {
      console.log('ORIGINAL GALLERY CONDITION');
      renderProductGallery(current_variant_id, 'original');
    }

    if (current_variant_id && current_variant_id !== 'undefined') {
      $('.stock-status-card').addClass('loading');
      const market = $('body').attr('data-market');

      var check_selling_policy = $(`.pdpVariantData li[data-vid="${current_variant_id}"]`).attr('data-selling-policy');
      var allowPreorder = check_selling_policy === '1'; // '1' = preorder allowed, '0' = not allowed

      // Fallback safety: clear the loading state even if the inventory
      // call fails or hangs.
      setTimeout(() => $('.stock-status-card').removeClass('loading'), 3000);

      fetchInventory(current_variant_id).then((inventory) => {
        if (!Array.isArray(inventory)) return;

        if (market === 'uk') {
          const qty = getLocationQuantity(
            inventory,
            'UK Warehouse'
          );
          const hasStock = qty !== null && qty > 0;

          renderStockStatus(
            current_variant_id,
            hasStock,
            'uk',
            allowPreorder
          );

          updateDispatchDateField(
            current_variant_id,
            hasStock,
            'uk'
          );
        } else if (market === 'canada') {
          const qty = getLocationQuantity(
            inventory,
            'CA Warehouse'
          );
          const hasStock = qty !== null && qty > 0;

          renderStockStatus(
            current_variant_id,
            hasStock,
            'ca',
            allowPreorder
          );

          updateDispatchDateField(
            current_variant_id,
            hasStock,
            'ca'
          );
        } else {
          /* const { hasStock } = getStockForLocations(
            inventory,
            US_WAREHOUSES
          );

          renderStockStatus(
            current_variant_id,
            hasStock,
            'us',
            allowPreorder
          );

          updateDispatchDateField(
            current_variant_id,
            hasStock,
            'us'
          ); */

          var total_qty = 0;

          if(US_WAREHOUSES){
            for(var i=0; i< US_WAREHOUSES.length; i++){
              var location = US_WAREHOUSES[i];
              
              if(location){
                var qty = getLocationQuantity(
                  inventory,
                  location
                );

              }

              total_qty += qty;
            }
          }

          const hasStock = total_qty !== null && total_qty > 0;

          renderStockStatus(
            current_variant_id,
            hasStock,
            'us',
            allowPreorder
          );

          updateDispatchDateField(
            current_variant_id,
            hasStock,
            'us'
          );

        }
      });
    }

    // ---- Pre-order / shipping estimate date display ----
    $('.variant_estimate_date').each(function () {
      var ship_date_var_id = $(this).attr('data-variant');
      var ship_pre_order_date = $(this).attr('data-ship-date');

      if (current_variant_id != null) {
        if (current_variant_id == ship_date_var_id) {
          $(`.variant_estimate_date[data-variant="${current_variant_id}"]`).removeClass('hide');
          $('.instock_estimate_days').addClass('hide');
        } else {
          $('.instock_estimate_days').removeClass('hide');
        }
      } else if (matching_variant_id == ship_date_var_id) {
        $(`.variant_estimate_date[data-variant="${matching_variant_id}"]`).removeClass('hide');
        $('.instock_estimate_days').addClass('hide');
      } else {
        $('.instock_estimate_days').removeClass('hide');
      }
    });

    $('.firts_product_media').addClass('hide');
    $(`.firts_product_media[product-media-variant="${matching_variant_id}"]`).removeClass('hide');

    const currentURL = new URL(window.location.href);
    const path_url = window.location.pathname.split('/')[2];
    if (path_url === 'cushie-modular-sleeper-sofa') {
      currentURL.searchParams.set('variant', matching_variant_id);
      $('input[name="id"]').val(matching_variant_id);
      window.history.pushState(null, '', currentURL.toString());
    }

    if(matching_variant_id){
      $('.w-commerce-commerceaddtocartform input[name="id"]').val(matching_variant_id);
    }

    const option = $(`.modular_variants option[variant-id="${matching_variant_id}"]`);
    const current_variant_qty = parseInt(option.attr('variant-qty'));
    const stock_available = option.attr('variant-stock') === 'true';
    const variant_price = option.attr('variant-price');
    const compare_price = option.attr('variant-comp-price');
    const variant_price_numeric = parseFloat(variant_price.replace(/[^0-9.]/g, '')) || 0;
    const compare_price_numeric = parseFloat(compare_price.replace(/[^0-9.]/g, '')) || 0;

    $('.modular_sofa .main_price span, .custom-container.pdp-menu .product-price.pdp, .prd_comp_price .product_tier_comp_price').text(variant_price);

    if ($('.sticky-atc-wrapper').length > 0) {
      const variantEl = $('.pdpVariantData li').filter(function () {
        return $(this).attr('data-title') === selected_variant_title;
      });

      const sale_enable = option.attr('variant-sale-enable');
      const sale_percent = parseFloat(option.attr('variant-discount')) || 0;

      if ($('.sticky-atc-wrapper span.atc-current-price').hasClass('atc-tier-current-price')) {
        if(compare_price_numeric > 0){
          $('.sticky-atc-wrapper .sticky-atc-container .atc-row .atc-col-right .atc-inner-row .atcPrice .atc-tier-compare-at').text(compare_price_numeric);
        }else{
          $('.sticky-atc-wrapper .sticky-atc-container .atc-row .atc-col-right .atc-inner-row .atcPrice .atc-tier-compare-at').text(variant_price_numeric);
        }
      }else if (sale_enable === 'true') {
        const difference = parseFloat((variant_price_numeric * sale_percent) / 100);
        const sale_price = (variant_price_numeric - difference).toFixed(2);
        const formattedsp = Number(sale_price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

        const stickyComparePrice =
          compare_price_numeric > variant_price_numeric
            ? compare_price
            : variant_price;

        $('.sticky-atc-wrapper .atcPrice .atc-compare-at')
          .text(stickyComparePrice)
          .removeClass('hide');
       
        $('.sticky-atc-wrapper .sticky-atc-container .atc-row .atc-col-right .atc-inner-row .atcPrice span.atc-current-price span.currentPrice').text(
          currency_symbol + formattedsp
        );
      } else {
        $('.sticky-atc-wrapper .sticky-atc-container .atc-row .atc-col-right .atc-inner-row .atcPrice span.atc-current-price span.currentPrice').text(
          currency + variant_price_numeric
        );
      }
    }

    if (variant_price) {
      const cleanPrice = parseFloat(variant_price.replace(/[^0-9.]/g, ''));
      const monthly = (cleanPrice / 12).toFixed(2);
      $('.metafield-string').html(' '+currency_symbol + `${monthly}/Month `);

      let tier_discount = 0;
      if (cleanPrice >= 500 && cleanPrice < 1200) {
        tier_discount = 15;
      } else if (cleanPrice >= 1200 && cleanPrice < 2000) {
        tier_discount = 20;
      } else if (cleanPrice >= 2000) {
        tier_discount = 25;
      }

      let newSalePrice = 0;
      if (tier_discount > 0) {
        const difference = (cleanPrice * tier_discount) / 100;
        newSalePrice = cleanPrice - difference;
      }

      if (newSalePrice > 0) {
        newSalePrice = formatPrice(newSalePrice);

        if ($('.price-text-holder .main_price1').length > 0) {
          $('.price-text-holder .main_price1 span').text(currency_symbol + `${newSalePrice}`);
        }

        if (
          $('.sticky-atc-wrapper').length > 0 &&
          $('.sticky-atc-wrapper span.atc-current-price').hasClass('atc-tier-current-price')
        ) {
          $('.sticky-atc-wrapper .sticky-atc-container .atc-row .atc-col-right .atc-inner-row .atcPrice span.atc-tier-current-price span.currentPrice').text(
            currency_symbol + `${newSalePrice}`
          );
        }
      }
    } else {
      $('.metafield-string').html('');
    }

    $('.pre_order_information').hide();
    if (current_variant_qty <= 0) {
      $('.stock_label').text('Low Stock').show();
    } else if (current_variant_qty <= 10) {
      $('.stock_label').text(`Only ${current_variant_qty} Left`).show();
    } else {
      $('.stock_label').text('Low in Stock').hide();
    }

    /* if (!stock_available && current_variant_qty <= 0) {
      $('.add-to-cart-holder .cart_pre_order_icon').hide();
      $('#primar-button').val('Out Of Stock').prop('disabled', true).attr('data-value', 'Out Of Stock');
      $('#sticky-atc-btn').text('Out Of Stock');
      $('.tooltip_icon, .delivery_banner').hide();
    } else if (current_variant_qty <= 0) {
      if ($('body').attr('data-market') == 'us') {
        $('#primar-button').val('Pre-Order').prop('disabled', false).attr('data-value', 'Pre-Order');
        $('#sticky-atc-btn').text('Pre-Order');
        $('.add-to-cart-holder .cart_pre_order_icon')
          .attr('src', 'https://cdn.shopify.com/s/files/1/0745/0876/3427/files/timer.png?v=1747280079')
          .addClass('pre-order')
          .show();
      }
      $(`.pre_order_information[variant-id="${matching_variant_id}"]`).show();
      $('.tooltip_icon').show();
      $('.delivery_banner').hide();
      $('.ship_stock_text').text('Pre-Order');
    } else {
      if ($('body').attr('data-market') == 'us') {
        $('#primar-button').val('Add To Cart').prop('disabled', false).attr('data-value', 'Add To Cart');
        $('#sticky-atc-btn').text('Add To Cart');
        $('.add-to-cart-holder .cart_pre_order_icon')
          .attr('src', 'https://cdn.shopify.com/s/files/1/0745/0876/3427/files/bag.svg?v=1756128418')
          .removeClass('pre-order')
          .show();
      }
      $('.pre-order-info-div, .tooltip_icon').hide();
      $('.delivery_banner').show();
      $('.ship_stock_text').text('In Stock');
    } */
  }

  // Usage:
  product_data(active_config_name, active_seater, active_color);

  $(document).on('click', '.configuration-options .config-item', function () {
    $('.seater-variant').hide().removeClass('active');
    $('.configuration-options .config-item').removeClass('active_configure active');
    $(this).addClass('active_configure active');

    var click_config = $(this).attr('data-config-name');
    var selected_config = $(this).attr('data-config-value');
    $('#selected-config').text(selected_config);

    $(`.seater-variant[seater-variant="${escapeSelector(click_config)}"]`).show();
    $(`.seater-variant[seater-variant="${escapeSelector(click_config)}"]`).first().addClass('active');
    var selected_seater_value = $(`.seater-variant[seater-variant="${escapeSelector(click_config)}"]`).first().attr('seater-value');
    $('.selected_seater_title').text(selected_seater_value);

    var change_seater = $('.seater-variant.active').attr('seater-value');
    var change_color = $('.product_color_values.active_color').attr('data-color');
    product_data(selected_config, change_seater, change_color);
  });

  $('.seater-variant').click(function () {
    $('.seater-variant').removeClass('active');
    $(this).addClass('active');

    var select_seater_value = $(this).attr('seater-value');
    $('.selected_seater_title').text(select_seater_value);

    var change_config = $('.config-item.active_configure').attr('data-config-value');
    var change_color = $('.product_color_values.active_color').attr('data-color');
    product_data(change_config, select_seater_value, change_color);
  });

  $('.product_color_values').click(function () {
    $('.product_color_values').removeClass('active_color active');
    $(this).addClass('active_color active');

    var selected_color = $(this).attr('data-color');
    $('.selected_color_name').text(selected_color);

    var change_config = $('.config-item.active_configure').attr('data-config-value');
    var change_seater = $('.seater-variant.active').attr('seater-value');
    product_data(change_config, change_seater, selected_color);
  });
});

// ----------------------------------------------------------------------------
// Variation swatch → dispatch date (used on /sleeper-sofa-2-01 and elsewhere)
// ----------------------------------------------------------------------------

if (typeof jQuery === 'undefined' || typeof Shopify === 'undefined') {
  console.error('jQuery or Shopify not loaded');
} else {
  jQuery(document).ready(function ($) {
    const currentUrl = window.location.pathname;

    setTimeout(function () {
      var variation_date = $('.variant_estimate_date:not(.hide)').data('ship-date');
      $('#properties').val(variation_date);
    }, 500);

    if (currentUrl.includes('/sleeper-sofa-2-01')) {
      $(document).on('click', '.variation-swatch', function () {
        var variation_date = $('.variant_estimate_date:not(.hide)').data('ship-date');
        $('#properties').val(variation_date);

        const salePrice = $(this).data('variant-price');
        if (!salePrice) {
          console.error('No variant price found');
          return;
        }

        const percentValue = parseFloat($('.sale_left_content').data('percent-value')) || 0;
        const minusValue = parseFloat($('.sale_left_content').data('minus-value')) || 0;
        const originalPrice = parseFloat(salePrice.replace(/,/g, '')) || 0;

        const variantPrice =
          percentValue > 0
            ? (originalPrice - (originalPrice * percentValue) / 100).toFixed(2)
            : (originalPrice - minusValue).toFixed(2);

        $('span.variant-price').text(Shopify.formatMoney(variantPrice * 100, '${{amount}}'));
        $('span.original-price > s').text(Shopify.formatMoney(originalPrice * 100, '${{amount}}'));
      });
    } else {
      $(document).on('click', '.variation-swatch', function () {
        var variation_date = $('.variant_estimate_date:not(.hide)').data('ship-date');
        $('#properties').val(variation_date);
      });
    }
  });
}

// ----------------------------------------------------------------------------
// Variant option selector → dispatch date field
// ----------------------------------------------------------------------------

function updateDispatchDateField(current_variant_id, hasStock, marketPrefix) {
  const deliveryDate = $(`.bulkUrgencyWrap .bulk-ug[data-vid="${current_variant_id}"]`).attr(`data-${marketPrefix}-date`);

  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  const [month, day] = deliveryDate.split(" ");

  // Create start Date object
  const startDate = new Date(
    new Date().getFullYear(),
    months.indexOf(month),
    parseInt(day, 10)
  );

  // Clone and add 7 days
  const endDate = new Date(startDate);
  endDate.setDate(endDate.getDate() + 7);

  // Display format
  const start_date = `${startDate.getDate()} ${months[startDate.getMonth()]}`;
  const end_date = `${endDate.getDate()} ${months[endDate.getMonth()]}`;

  // Hidden format (YYYY-MM-DD)
  const start_date_hidden = `${startDate.getFullYear()}-${String(startDate.getMonth() + 1).padStart(2, '0')}-${String(startDate.getDate()).padStart(2, '0')}`;

  const end_date_hidden = `${endDate.getFullYear()}-${String(endDate.getMonth() + 1).padStart(2, '0')}-${String(endDate.getDate()).padStart(2, '0')}`;

  // $('input[name="properties[Dispatch Date]"]').val(hasStock ? 'Ships in 1-2 days' : deliveryDate);

  if(hasStock){
  }else{
    $('input[name="eta_preorder"]').val(`${start_date} - ${end_date}`);
    $('input[name="pre_order_start_date"]').val(start_date_hidden);
    $('input[name="pre_order_end_date"]').val(end_date_hidden);
  }

}

$(document).on('click', '.variant-productOption .selectvarentcc', function () {
  var total_options = $('.variant-productOption').length;
  var selected_option1 = $('.variant-productOption[data-option-id="0"] .selectvarentcc.active').attr('data-value') || '';
  var selected_option2 =
    total_options >= 2 ? $('.variant-productOption[data-option-id="1"] .selectvarentcc.active').attr('data-value') || '' : '';
  var selected_option3 =
    total_options >= 3 ? $('.variant-productOption[data-option-id="2"] .selectvarentcc.active').attr('data-value') || '' : '';

  var selected_variant_name = [selected_option1, selected_option2, selected_option3].filter(Boolean).join(' / ');
  var selected_variant_id = '';

  if (selected_variant_name) {
    $('.pdpVariantData li').each(function () {
      if ($(this).attr('data-title') == selected_variant_name) {
        selected_variant_id = $(this).attr('data-vid');
      }
    });
  }

  if (!selected_variant_id) return;

  var market = $('body').attr('data-market');

  var check_selling_policy = $(`.pdpVariantData li[data-vid="${selected_variant_id}"]`).attr('data-selling-policy');
  var allowPreorder = check_selling_policy === '1'; // attr() always returns a string

  fetchInventory(selected_variant_id).then((inventory) => {
    if (!Array.isArray(inventory)) return;

    if (market === 'uk') {
      const qty = getLocationQuantity(inventory, 'UK Warehouse');
      updateDispatchDateField(selected_variant_id, qty !== null && qty > 0, 'uk');
    } else if (market === 'canada') {
      const qty = getLocationQuantity(inventory, 'CA Warehouse');
      updateDispatchDateField(selected_variant_id, qty !== null && qty > 0, 'ca');
    } else {
      /* const { hasStock } = getStockForLocations(inventory, US_WAREHOUSES);
      updateDispatchDateField(selected_variant_id, hasStock, 'us'); */

      var total_qty = 0;

      if(US_WAREHOUSES){
        for(var i=0; i< US_WAREHOUSES.length; i++){
          var location = US_WAREHOUSES[i];
          
          if(location){
            var qty = getLocationQuantity(
              inventory,
              location
            );

          }

          total_qty += qty;
        }
      }

      updateDispatchDateField(selected_variant_id, qty !== null && total_qty > 0, 'us')

    }
  });

});

// ----------------------------------------------------------------------------
// Cart page: per-line-item shipping estimate
// ----------------------------------------------------------------------------

if ($('body').hasClass('template-cart')) {
  const market = $('body').attr('data-market');

  function updateCartItemShipping($item, hasStock, deliveryText, deliveryDate) {
    // $item.find('.cart_item_properties').text(hasStock ? 'Ships in 1-2 days' : deliveryText);
    if(hasStock){
      $item.find('.cart_item_properties').text('Ships in 1-2 days');
    }else{

      const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];

      // Input is "21 Aug"
      const [day, month] = deliveryDate.split(" ");

      // Create start date
      const startDate = new Date(
        new Date().getFullYear(),
        months.indexOf(month),
        parseInt(day, 10)
      );

      // Create end date (+7 days)
      const endDate = new Date(startDate);
      endDate.setDate(endDate.getDate() + 7);

      // Display format
      const start_date = `${startDate.getDate()} ${months[startDate.getMonth()]}`;
      const end_date = `${endDate.getDate()} ${months[endDate.getMonth()]}`;

      $item.find('.cart_item_properties').text(`Pre Order - ETA: ${start_date} - ${end_date}`);
    }
  }

  $('.cart_items_ .cart-item-3').each(function () {
    const $item = $(this);
    const current_variant_id = $item.attr('data-id');
    if (!current_variant_id) return;

    fetchInventory(current_variant_id).then((inventory) => {
      if (!Array.isArray(inventory)) return;

      if (market === 'uk') {
        const qty = getLocationQuantity(inventory, 'UK Warehouse');
        $('body').attr('uk-inventory', qty);
        updateCartItemShipping($item, qty !== null && qty > 0, $item.attr('data-uk-preorder'), $item.attr('data-uk-preorder-date'));
      } else if (market === 'canada') {
        const qty = getLocationQuantity(inventory, 'CA Warehouse');
        $('body').attr('ca-inventory', qty);
        updateCartItemShipping($item, qty !== null && qty > 0, $item.attr('data-ca-preorder'), $item.attr('data-ca-preorder-date'));
      } else {
       /* const { hasStock, quantities } = getStockForLocations(inventory, US_WAREHOUSES);
        $('body').attr('us-inventory', quantities[quantities.length - 1] ?? 0);
        updateCartItemShipping($item, hasStock, $item.attr('data-us-preorder'), $item.attr('data-us-preorder-date')); */

        var total_qty = 0;

        if(US_WAREHOUSES){
          for(var i=0; i< US_WAREHOUSES.length; i++){
            var location = US_WAREHOUSES[i];
            
            if(location){
              var qty = getLocationQuantity(inventory, location);
            }

            total_qty += qty;
          }
        }

        $('body').attr('us-inventory', total_qty);
        updateCartItemShipping($item, total_qty !== null && total_qty > 0, $item.attr('data-us-preorder'), $item.attr('data-us-preorder-date'));
      }
    });
  });
}

if ($('body').hasClass('template-product')) {
  setTimeout(function () {
    const market = $('body').attr('data-market');
    const current_variant_id = $('#hero_top_link_aa').attr('data-vid');
    if (!current_variant_id) return;

    fetchInventory(current_variant_id).then((inventory) => {
      if (!Array.isArray(inventory)) return;

      if (market === 'uk') {
        const qty = getLocationQuantity(inventory, 'UK Warehouse');
        $('body').attr('uk-inventory', qty);
        updateDispatchDateField(current_variant_id, qty !== null && qty > 0, 'uk');
      } else if (market === 'canada') {
        const qty = getLocationQuantity(inventory, 'CA Warehouse');
        $('body').attr('ca-inventory', qty);
        updateDispatchDateField(current_variant_id, qty !== null && qty > 0, 'ca');
      } else {
        /* const { hasStock, quantities } = getStockForLocations(inventory, US_WAREHOUSES);
        const totalAvailableStock = quantities.reduce((sum, n) => sum + (parseInt(n, 10) || 0), 0);
        $('body').attr('us-inventory', totalAvailableStock);
        updateDispatchDateField(current_variant_id, hasStock, 'us'); */

        var total_qty = 0;

        if(US_WAREHOUSES){
          for(var i=0; i< US_WAREHOUSES.length; i++){
            var location = US_WAREHOUSES[i];
            
            if(location){
              var qty = getLocationQuantity(
                inventory,
                location
              );

            }

            total_qty += qty;
          }
        }

        $('body').attr('us-inventory', total_qty);
        updateDispatchDateField(current_variant_id, total_qty !== null && total_qty > 0, 'us');

      }
    });
  }, 1000);
}


if($('.pdp-airflow').length > 0){
  document.querySelectorAll('.product_color_variants .product_color_values').forEach(function (option) {
    option.addEventListener('click', function () {
      var selectedColor = option.dataset.color;
      var sizeSelector = document.querySelector('.configuration-options .config-item.active');

      var selectedSize = '';

      if(sizeSelector){
        selectedSize = sizeSelector.dataset.value;
      }

      if (!selectedColor) {
        return;
      }
      var currentSelectedColor = selectedColor
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-');

      var currentSelectedSize = selectedSize.trim().toLowerCase();

      setTimeout(function(){
        document.querySelectorAll('.aw-product-size-table').forEach(function (sizeTable) {
          var colorSelect = sizeTable.querySelector('.product-color-select');
          if (!colorSelect) {
            return;
          }

          var sizeOptions = sizeTable.querySelectorAll('.size-guide-item');
          if (!sizeOptions.length) {
            return;
          }

          var selectedColorElement = colorSelect.querySelector(
            '.product-color-selected'
          );
          var colorOptions = colorSelect.querySelectorAll(
            '.product-color-option'
          );
          colorOptions.forEach(function (colorOption) {
            var optionColor = (colorOption.dataset.color || '')
              .trim()
              .toLowerCase()
              .replace(/\s+/g, '-');

            colorOption.classList.remove('active');
            if (optionColor === currentSelectedColor) {
              colorOption.classList.add('active');
              if (selectedColorElement) {
                selectedColorElement.textContent = colorOption.textContent.trim();
              }
            }
          });

          sizeOptions.forEach(function (sizeOption) {
            var optionSize = (sizeOption.dataset.value || '')
              .trim()
              .toLowerCase();

            sizeOption.classList.remove('active');

            if (optionSize === currentSelectedSize) {
              sizeOption.classList.add('active');
            }
          });

        });
      }, 1000);
      
    });
  });



  document.querySelectorAll('.configuration-options .config-item').forEach(function (option) {
    option.addEventListener('click', function () {

      var selectedSize = option.dataset.value;

      var colorSelector = document.querySelector(
        '.product_color_options .product_color_values.active'
      );

      var selectedColor = '';

      if (colorSelector) {
        selectedColor = colorSelector.dataset.color;
      }

      if (!selectedSize || !selectedColor) {
        return;
      }

      var currentSelectedSize = selectedSize
        .trim()
        .toLowerCase();

      var currentSelectedColor = selectedColor
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-');

      setTimeout(function () {

        document.querySelectorAll('.aw-product-size-table').forEach(function (sizeTable) {

          /*
          * --------------------------------
          * Color dropdown
          * --------------------------------
          */
          var colorSelect = sizeTable.querySelector('.product-color-select');

          if (colorSelect) {

            var selectedColorElement = colorSelect.querySelector(
              '.product-color-selected'
            );

            var colorOptions = colorSelect.querySelectorAll(
              '.product-color-option'
            );

            colorOptions.forEach(function (colorOption) {

              var optionColor = (colorOption.dataset.color || '')
                .trim()
                .toLowerCase()
                .replace(/\s+/g, '-');

              colorOption.classList.remove('active');

              if (optionColor === currentSelectedColor) {

                colorOption.classList.add('active');

                if (selectedColorElement) {
                  selectedColorElement.textContent =
                    colorOption.textContent.trim();
                }

              }

            });

          }

          /*
          * --------------------------------
          * Size options
          * --------------------------------
          */
          var sizeOptions = sizeTable.querySelectorAll(
            '.size-guide-item'
          );

          if (!sizeOptions.length) {
            return;
          }

          sizeOptions.forEach(function (sizeOption) {

            var optionSize = (sizeOption.dataset.value || '')
              .trim()
              .toLowerCase();

            sizeOption.classList.remove('active');

            if (optionSize === currentSelectedSize) {
              sizeOption.classList.add('active');
            }

          });

        });

      }, 1000);

    });
  });


  document.addEventListener('click', function (event) {
    const button = event.target.closest('.product-color-select-button');
    if (button) {
      const dropdown = button.closest('.product-color-select');
      dropdown.classList.toggle('open');
      return;
    }

    const option = event.target.closest('.product-color-option');
    if (option) {
      const dropdown = option.closest('.product-color-select');
      const selectedColor = dropdown.querySelector('.product-color-selected');

      var optionMain = option.closest('.aw-options-main');
      var sizeSelector = optionMain
        ? optionMain.querySelector('.aw-size-options .size-guide-item.active')
        : null;

      var selectedSize = sizeSelector
        ? sizeSelector.getAttribute('data-value')
        : '';

      // Update selected color
      selectedColor.textContent = option.dataset.color;

      var currentVID = 0;

      var pdpVariantData = document.querySelector('.pdpVariantData');
      if (pdpVariantData) {
        var variants = pdpVariantData.querySelectorAll('li');
        variants.forEach(function (variant) {
          var dataTitle = (variant.dataset.title || '').toLowerCase();
          var color = (option.dataset.color || '').toLowerCase();
          var size = (selectedSize || '').toLowerCase();
          if (dataTitle.includes(color) && dataTitle.includes(size)) {
            currentVID = variant.dataset.vid;
          }
        });
      }

      if (currentVID) {
        const sizeGuideTemplate = document.getElementById(
        'product-size-guide-data'
        );
        const sizeGuideDataNode = sizeGuideTemplate?.content.querySelector(`.productSizeGuideInfo[data-var-id="${currentVID}"]`);
        const $sizeGuideData = $(sizeGuideDataNode || []);
        if ($sizeGuideData) {
          var popupHtml = $sizeGuideData.find('.productPopupInformation .aw-size-guide-main').html();
          if (popupHtml) {
            var popupVariant = document.querySelector('.product_meta_popup_variant');
            if (popupVariant) {
              popupVariant.setAttribute('product-var-id', currentVID);
              var popupTable = popupVariant.querySelector('.aw-product-size-table .aw-size-guide-main');
              if (popupTable) {
                popupTable.innerHTML = popupHtml;
              }
            }
          }
        }
      }

      // Update active option
      dropdown.querySelectorAll('.product-color-option').forEach(function (item) {
        item.classList.remove('active');
      });
      option.classList.add('active');
      // Close dropdown
      dropdown.classList.remove('open');
      
      if (option.dataset.color) {
        var currentSelectedColor = option.dataset.color.toLowerCase();
        var container = option.closest('.product-size-guide-airflow');

        if (container) {
          var sizeGuides = container.querySelectorAll('.aw-size-guide');

          sizeGuides.forEach(function (guide) {
            guide.style.display = 'none';
          });

          var selectedGuide = container.querySelector(
            '.aw-size-guide[data-color="' + currentSelectedColor + '"]'
          );

          if (selectedGuide) {
            selectedGuide.style.display = 'block';
          }
        }
      }

    }
  });


  document.addEventListener('click', function (event) {
    const sizeGuideItem = event.target.closest(
      '.product_size_guide_wrap .product_meta_popup_variant .aw-options-main .size-guide-item'
    );

    if (!sizeGuideItem) {
      return;
    }

    // Add active class to selected size
    sizeGuideItem.classList.add('active');

    // Remove active class from other size options
    const parent = sizeGuideItem.parentElement;

    if (parent) {
      parent.querySelectorAll('.size-guide-item').forEach(function (item) {
        if (item !== sizeGuideItem) {
          item.classList.remove('active');
        }
      });
    }

    // Get selected size
    const selectedSize = sizeGuideItem.getAttribute('data-value') || '';

    // Get selected color
    const optionsMain = sizeGuideItem.closest('.aw-options-main');

    const activeColor = optionsMain
      ? optionsMain.querySelector(
          '.aw-color-options .product-color-option.active'
        )
      : null;

    const selectedColor = activeColor
      ? activeColor.getAttribute('data-color') || ''
      : '';

    let currentVID = 0;

    // Find PDP variant data
    const pdpVariantData = document.querySelector('.pdpVariantData');

    if (pdpVariantData) {
      const variants = pdpVariantData.querySelectorAll('li');

      variants.forEach(function (variant) {
        const dataTitle = (
          variant.getAttribute('data-title') || ''
        ).toLowerCase();

        const color = selectedColor.toLowerCase();
        const size = selectedSize.toLowerCase();

        if (
          dataTitle.includes(color) &&
          dataTitle.includes(size)
        ) {
          currentVID = variant.getAttribute('data-vid');

        }
      });
    }

    // Update size guide
    if (currentVID) {
      const sizeGuideTemplate = document.getElementById(
        'product-size-guide-data'
      );

      if (!sizeGuideTemplate) {
        console.log('Size guide template not found');
        return;
      }

      const sizeGuideDataNode =
        sizeGuideTemplate.content.querySelector(
          `.productSizeGuideInfo[data-var-id="${currentVID}"]`
        );

      if (!sizeGuideDataNode) {
        console.log(
          'No size guide data found for variant:',
          currentVID
        );
        return;
      }

      const popupContent =
        sizeGuideDataNode.querySelector(
          '.productPopupInformation .aw-size-guide-main'
        );

      if (!popupContent) {
        console.log('Popup content not found');
        return;
      }

      const popupHtml = popupContent.innerHTML;

      const popupVariant = document.querySelector(
        '.product_meta_popup_variant'
      );

      if (!popupVariant) {
        console.log('Popup variant not found');
        return;
      }

      popupVariant.setAttribute(
        'product-var-id',
        currentVID
      );

      const popupTable = popupVariant.querySelector(
        '.aw-product-size-table .aw-size-guide-main'
      );

      if (popupTable) {
        popupTable.innerHTML = popupHtml;

        console.log(
          'Size guide updated successfully:',
          currentVID
        );
      } else {
        console.log('Popup table not found');
      }
    } else {
      console.log('No matching variant found');
    }
  });


  document.addEventListener('click', function (event) {
    const playButton = event.target.closest('.assembly-video-play');

    if (!playButton) {
      return;
    }

    const wrapper = playButton.closest('.assembly-video-wrapper');

    if (!wrapper) {
      return;
    }

    const video = wrapper.querySelector('.assembly-video');

    if (!video) {
      return;
    }

    // Enable native video controls
    video.controls = true;

    // Play video
    video.play();

    // Hide custom play button
    playButton.style.display = 'none';

    // Show play button again when video ends
    video.addEventListener('ended', function () {
      playButton.style.display = 'flex';
    }, { once: true });
  });

}